
export const nav = {
  home: 'Головна',
  about: 'Про нас',
  courses: 'Курси',
  wallOfFame: 'Стіна слави',
  workWithUs: 'Працювати з нами',
  contact: 'Контакти'
};

export const cta = {
  bookClass: 'Записатися на урок',
  startLearning: 'Почати навчання сьогодні',
  learnMore: 'Дізнатися більше',
  enroll: 'Записатися зараз',
  apply: 'Подати заявку',
  contact: 'Зв\'язатися з нами',
  readyToStart: 'Готові почати навчання?',
  joinThousands: 'Приєднуйтесь до тисяч студентів, які вже досягли успіху з MathLish'
};

export const hero = {
  title: 'Вивчайте математику та англійську онлайн з експертними викладачами',
  subtitle: 'Приєднуйтесь до тисяч студентів, які досягли успіху з MathLish. Персоналізоване навчання з досвідченими викладачами.',
  experience: 'Понад 20 років педагогічного досвіду',
  qualifiedTeachers: 'Кваліфіковані викладачі',
  onlineLearning: 'Онлайн навчання',
  provenResults: 'Доведені результати'
};

export const about = {
  title: 'Про MathLish',
  subtitle: 'Ваш шлях до успіху в математиці та англійській',
  description: 'MathLish - провідна онлайн-платформа для вивчення математики та англійської мови, заснована вчителькою Іриною, кваліфікованим викладачем математики з понад 20-річним досвідом викладання.',
  mission: 'Наша місія - зробити якісну освіту доступною для кожного студента через персоналізований підхід та інноваційні методи навчання.',
  whyChoose: 'Чому обирають MathLish',
  meetTeacher: 'Знайомтесь з вчителькою Іриною',
  ourValues: 'Наші цінності',
  valuesSubtitle: 'Принципи, які керують нашою роботою',
  ctaSubtitle: 'Приєднуйтесь до нашої спільноти та досягніть нових висот у навчанні',
  countries: 'Країн по всьому світу',
  qualifications: {
    qualified: 'Кваліфікований викладач математики',
    experience: 'Понад 20 років педагогічного досвіду',
    online: 'Експерт з онлайн-освіти',
    founder: 'Засновниця платформи MathLish'
  },
  values: {
    passion: 'Пристрасть до навчання',
    passionDesc: 'Ми віримо, що навчання має бути захоплюючим та надихаючим процесом',
    innovation: 'Інноваційні методи',
    innovationDesc: 'Ми використовуємо найновіші технології та методики викладання'
  },
  reasons: {
    experience: 'Досвідчені викладачі',
    experienceDesc: 'Понад 20 років освітнього досвіду',
    personalized: 'Персоналізований підхід',
    personalizedDesc: 'Індивідуальні програми для кожного студента',
    flexible: 'Гнучкий графік',
    flexibleDesc: 'Навчайтесь у зручний для вас час',
    results: 'Доведені результати',
    resultsDesc: 'Тисячі успішних випускників'
  }
};

export const courses = {
  title: 'Наші курси',
  subtitle: 'Оберіть ідеальний курс для ваших потреб',
  mathematics: 'Математика',
  english: 'Англійська мова',
  mathDescription: 'Вивчайте математику з вчителькою Іриною',
  englishDescription: 'Вивчайте англійську з досвідченими викладачами',
  pricing: 'Ціни',
  perClass: 'за урок',
  perStudent: 'за студента',
  oneOnOne: 'Індивідуально',
  twoStudents: 'Два студенти',
  fourStudents: 'Чотири студенти',
  sixStudents: 'Шість студентів',
  whatIncludes: 'Що включають наші курси',
  everythingNeeded: 'Все необхідне для успішного навчання',
  readyToStart: 'Готові розпочати навчання?',
  chooseAndStart: 'Оберіть курс та почніть свій шлях до успіху вже сьогодні',
  features: {
    interactive: 'Інтерактивні уроки',
    materials: 'Навчальні матеріали',
    support: 'Підтримка 24/7',
    progress: 'Відстеження прогресу',
    onlineLessons: 'Онлайн уроки',
    onlineLessonsDesc: 'Інтерактивні відеоуроки в реальному часі',
    materialsDesc: 'Сучасні підручники та додаткові ресурси',
    expertTeachers: 'Експертні викладачі',
    expertTeachersDesc: 'Досвідчені та кваліфіковані педагоги',
    flexible: 'Гнучкий графік',
    flexibleDesc: 'Оберіть зручний час для занять',
    supportDesc: 'Цілодобова технічна та академічна підтримка',
    personalApproach: 'Персональний підхід',
    flexibleSchedule: 'Гнучкий графік',
    individualProgram: 'Індивідуальна програма',
    interactiveLearning: 'Інтерактивне навчання',
    peerInteraction: 'Взаємодія з однолітками',
    costSaving: 'Економія коштів',
    groupDynamics: 'Групова динаміка',
    bestPrice: 'Найкраща ціна',
    socialLearning: 'Соціальне навчання',
    conversationPractice: 'Розмовна практика',
    pairWork: 'Парна робота',
    interactiveTasks: 'Інтерактивні завдання',
    groupDiscussions: 'Групові дискусії',
    rolePlay: 'Рольові ігри',
    teamwork: 'Командна робота',
    largeProjects: 'Великі проекти',
    presentations: 'Презентації',
    debates: 'Дебати'
  }
};

export const stats = {
  title: 'Наші досягнення',
  subtitle: 'Цифри, які говорять самі за себе',
  students: 'Студентів',
  experience: 'Років досвіду',
  success: 'Успішність',
  support: 'Підтримка'
};

export const wallOfFame = {
  title: 'Стіна слави',
  subtitle: 'Досягнення наших студентів',
  achievements: 'Досягнення',
  testimonials: 'Відгуки',
  results: 'Результати',
  achievementsSubtitle: 'Наші студенти досягають неймовірних результатів',
  testimonialsSubtitle: 'Що кажуть наші студенти та їхні батьки',
  ctaTitle: 'Станьте частиною нашої Стіни слави!',
  ctaSubtitle: 'Приєднуйтесь до тисяч успішних студентів MathLish',
  students: {
    alexandra: 'Олександра Петренко',
    maxim: 'Максим Коваленко',
    anna: 'Анна Сидоренко',
    dmytro: 'Дмитро Іваненко',
    sofia: 'Софія Мельник',
    artem: 'Артем Бондаренко'
  },
  achievements2: {
    mathOlympiad: 'Переможець олімпіади з математики',
    ielts: 'Результат IELTS 8.5',
    university: 'Вступ до престижного університету',
    cambridge: 'Кембриджський сертифікат',
    international: 'Міжнародна олімпіада',
    toefl: 'Результат TOEFL 115'
  },
  testimonials2: {
    maria: 'Марія Шевченко',
    andriy: 'Андрій Кравченко',
    olena: 'Олена Гриценко',
    mariaText: 'Дякую MathLish за відмінні результати! Моя донька значно покращила свої знання з математики.',
    andriyText: 'Завдяки урокам англійської в MathLish я отримав 8 балів на IELTS! Рекомендую всім.',
    olenaText: 'Професійний підхід та індивідуальна увага до кожного студента. Мій син показує відмінні результати.'
  },
  roles: {
    mother: 'Мама студента',
    student: 'Студент',
    father: 'Тато студента'
  },
  stats: {
    graduates: 'Успішних випускників',
    improvement: 'Покращення оцінок',
    university: 'Вступ до університету',
    satisfaction: 'Рейтинг задоволеності'
  }
};

export const workWithUs = {
  title: 'Працювати з нами',
  subtitle: 'Приєднуйтесь до нашої команди викладачів',
  description: 'Ми шукаємо талановитих викладачів математики та англійської мови для приєднання до нашої команди.',
  requirements: 'Вимоги',
  benefits: 'Переваги',
  applicationForm: 'Форма заявки',
  joinTeam: 'Приєднуйтесь до нашої команди викладачів',
  whyJoin: 'Чому варто приєднатися до MathLish?',
  whyJoinDesc: 'MathLish - це місце, де ваш талант розкриється на повну силу',
  openPositions: 'Відкриті вакансії',
  findPosition: 'Знайдіть свою ідеальну позицію в нашій команді',
  joinProfessionals: 'Приєднуйтесь до нашої команди професіоналів',
  fillForm: 'Заповніть форму, і ми зв\'яжемося з вами найближчим часом',
  sendResume: 'Надіслати резюме',
  apply: 'Подати заявку',
  askQuestion: 'Поставити питання',
  readyToJoin: 'Готові приєднатися до нашої команди?',
  sendResumeToday: 'Надішліть своє резюме та станьте частиною MathLish вже сьогодні!',
  applicationProcess: 'Процес подачі заявки',
  processDesc: 'Простий та прозорий процес відбору',
  employment: {
    fullTime: 'Повний робочий день',
    partTime: 'Неповний робочий день'
  },
  location: {
    online: 'Онлайн',
    remote: 'Віддалено'
  },
  requirements2: {
    education: 'Вища освіта за профілем',
    experience: 'Мінімум 2 роки досвіду викладання',
    knowledge: 'Відмінне знання предмету',
    online: 'Досвід онлайн-викладання (бажано)',
    communication: 'Комунікативні навички',
    responsibility: 'Відповідальність та пунктуальність',
    englishLevel: 'Рівень англійської не нижче C1',
    pedagogical: 'Педагогічна освіта',
    curriculum: 'Досвід розробки навчальних програм',
    technology: 'Знання сучасних освітніх технологій',
    analytical: 'Аналітичні навички'
  },
  benefits2: {
    salary: 'Конкурентна заробітна плата',
    salaryDesc: 'Конкурентна зарплата та система бонусів',
    schedule: 'Гнучкий графік роботи',
    scheduleDesc: 'Можливість планувати власний робочий час',
    remote: 'Можливість працювати віддалено',
    development: 'Професійний розвиток',
    developmentDesc: 'Безкоштовні курси професійного розвитку',
    team: 'Дружня команда',
    teamDesc: 'Підтримка колег та комфортна робоча атмосфера',
    technology: 'Сучасні технології навчання',
    technologyDesc: 'Робота з найновішими освітніми платформами',
    package: 'Соціальний пакет',
    packageDesc: 'Медичне страхування та додаткові переваги'
  },
  positions: {
    mathTeacher: 'Викладач математики',
    mathDescription: 'Викладання математики для учнів різних рівнів',
    mathReq1: 'Вища математична освіта',
    mathReq2: 'Досвід викладання від 2 років',
    englishTeacher: 'Викладач англійської мови',
    englishDescription: 'Викладання англійської мови для різних вікових груп',
    englishReq1: 'Філологічна освіта',
    englishReq2: 'Сертифікат TESOL/TEFL (бажано)',
    methodist: 'Методист'
  },
  responsibilities: {
    individual: 'Проведення індивідуальних та групових занять',
    materials: 'Підготовка навчальних матеріалів',
    assessment: 'Оцінювання прогресу студентів',
    parents: 'Взаємодія з батьками студентів',
    interactive: 'Проведення інтерактивних уроків англійської',
    exams: 'Підготовка до міжнародних іспитів',
    monitoring: 'Моніторинг успішності студентів',
    development: 'Розробка навчальних матеріалів',
    analysis: 'Аналіз ефективності навчальних програм',
    support: 'Підтримка викладачів',
    quality: 'Контроль якості освітнього процесу'
  },
  steps: {
    submit: 'Подача резюме',
    submitDesc: 'Надішліть своє резюме через контактну форму',
    interview: 'Співбесіда',
    interviewDesc: 'Онлайн-співбесіда з HR-менеджером та методистом',
    demo: 'Демо-урок',
    demoDesc: 'Проведення демонстраційного уроку',
    contract: 'Контракт',
    contractDesc: 'Підписання контракту та початок роботи'
  },
  form: {
    name: 'Повне ім\'я',
    email: 'Електронна пошта',
    phone: 'Телефон',
    subject: 'Предмет викладання',
    experience: 'Досвід викладання (років)',
    message: 'Розкажіть про себе та свій досвід',
    send: 'Надіслати заявку',
    sending: 'Відправляємо...',
    namePlaceholder: 'Введіть ваше повне ім\'я',
    selectSubject: 'Оберіть предмет',
    selectExperience: 'Оберіть досвід',
    'exp1-2': '1-2 роки',
    'exp3-5': '3-5 років',
    'exp6-10': '6-10 років',
    'exp10+': 'Більше 10 років',
    messagePlaceholder: 'Розкажіть про свою освіту, досвід викладання, методики, які ви використовуєте...',
    maxChars: 'Максимум 500 символів',
    successMessage: 'Дякуємо за вашу заявку! Ми зв\'яжемося з вами найближчим часом.',
    errorMessage: 'Виникла помилка при відправці форми. Спробуйте ще раз.'
  }
};

export const contact = {
  title: 'Зв\'язатися з нами',
  subtitle: 'Готові почати навчання? Зв\'яжіться з нами сьогодні!',
  getInTouch: 'Зв\'язатися з нами',
  contactInfo: 'Контактна інформація',
  sendMessage: 'Надішліть нам повідомлення',
  chooseMethod: 'Оберіть зручний спосіб зв\'язку з нами',
  workingHours: 'Години роботи',
  schedule: 'Пн-Пт: 9:00-18:00',
  form: {
    name: 'Ім\'я',
    email: 'Електронна пошта',
    phone: 'Телефон',
    subject: 'Тема',
    message: 'Повідомлення',
    send: 'Надіслати повідомлення',
    sending: 'Відправляємо...',
    namePlaceholder: 'Ваше ім\'я',
    messagePlaceholder: 'Розкажіть детальніше про ваше питання або запит...',
    selectSubject: 'Оберіть тему',
    maxChars: 'Максимум 500 символів',
    successMessage: 'Дякуємо за ваше повідомлення! Ми зв\'яжемося з вами найближчим часом.',
    errorMessage: 'Виникла помилка при відправці повідомлення. Спробуйте ще раз.'
  },
  subjects: {
    enrollment: 'Запис на курси',
    pricing: 'Питання про ціни',
    schedule: 'Графік занять',
    technical: 'Технічна підтримка',
    other: 'Інше'
  },
  faq: {
    title: 'Часті питання',
    booking: {
      question: 'Як записатися на урок?',
      answer: 'Ви можете записатися через форму на сайті, зателефонувати нам або написати на email. Ми зв\'яжемося з вами для узгодження деталей.'
    },
    schedule: {
      question: 'Чи можна змінити час уроку?',
      answer: 'Так, ми пропонуємо гнучкий графік. Повідомте нас заздалегідь, і ми знайдемо зручний час для перенесення уроку.'
    },
    technical: {
      question: 'Які технічні вимоги для онлайн-уроків?',
      answer: 'Вам потрібен комп\'ютер або планшет з камерою, мікрофоном та стабільним інтернет-з\'єднанням. Ми використовуємо зручні платформи для навчання.'
    },
    materials: {
      question: 'Чи надаєте ви навчальні матеріали?',
      answer: 'Так, всі необхідні навчальні матеріали надаються безкоштовно. Це включає підручники, завдання та додаткові ресурси.'
    }
  }
};

export const footer = {
  description: 'Провідна онлайн-платформа для вивчення математики та англійської мови з досвідченими викладачами.',
  quickLinks: 'Швидкі посилання',
  contact: 'Контакти',
  location: 'Україна',
  rights: 'Всі права захищені.'
};

export default {
  nav,
  cta,
  hero,
  about,
  courses,
  stats,
  wallOfFame,
  workWithUs,
  contact,
  footer
};
